import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { PageResp } from 'src/app/core/models/page/page-response';
import { environment } from 'src/environments/environment';
import { ExportRecommandForwarderResponse } from '../../setting/pages/forwarder-setting-export/interface/export-recommand-forwarder-data-table';

@Injectable({
  providedIn: 'root'
})
export class ForwarderService {

  constructor(
    private http: HttpClient
  ) { }

  /**
   * Get RMB Recommand Forwarder.
   */
  getRMBRecommandFrowarder(): Observable<any> {
    const url = `${environment.logisticsApiUrl}/forwarder/rmbRecommandForwarder`;
    return this.http.get(url);
  }

  /**
   * Get Forwarder Options for DropDown
   */
   getForwarderOptions(): Observable<any> {
    const url = `${environment.logisticsApiUrl}/forwarder`;
    return this.http.get(url);
  }

   /**
   * Get Erp Forwarder Options for DropDown
   */
   getErpForwarderOptions(): Observable<any> {
    const url = `${environment.logisticsApiUrl}/facilityOptions/erpForwarder`;
    return this.http.get(url);
  }

  getForwarderOptionsAll(): Observable<any> {
    const url = `${environment.logisticsApiUrl}/forwarder/getForwarderOptionsAll`;
    return this.http.post(url, {});
  }

  getExportRecommendForwarderSetting(params: any): Observable<PageResp<ExportRecommandForwarderResponse>>{
    const url = `${environment.logisticsApiUrl}/forwarder/getExportRecommendForwarderSetting`;
    return this.http.post<PageResp<ExportRecommandForwarderResponse>>(url, params);
  }

  saveExportRecommendForwarderSetting(params: any): Observable<any>{
    const url = `${environment.logisticsApiUrl}/forwarder/saveExportRecommendForwarderSetting`;
    return this.http.post(url, params);
  }

  getRecommendForwarderSetting(params: any,forwarderType:string): Observable<any>{
    const url = `${environment.logisticsApiUrl}/forwarder/get`+forwarderType+`RecommendForwarderSetting`;

    return this.http.post(url, params);
  }

  saveRecommendForwarderSetting(params: any,forwarderType:string): Observable<any>{
    const url = `${environment.logisticsApiUrl}/forwarder/save`+forwarderType+`RecommendForwarderSetting`;
    return this.http.post(url, params);
  }

  deleteRecommendForwarder(seqNoList: any,forwarderType:string): Observable<any>{
    const url = `${environment.logisticsApiUrl}/forwarder/delete`+forwarderType+`RecommendForwarder/deleteList`;
    return this.http.post(url,seqNoList);
  }

  async getPoolCodeOptions(params: any): Promise<any> {
    const url = `${environment.logisticsApiUrl}/forwarder/getCarPoolCode`;
    return await this.http.post(url, params).toPromise();
  }

  deleteExportRecommendForwarder(params: any): Observable<any>{
    const url = `${environment.logisticsApiUrl}/forwarder/deleteExportRecommendForwarder`;
    return this.http.post(url, params);
  }

  getForwarderIsExpress(facilityCode: string, isExpress: number): Observable<any>{
    const url = `${environment.logisticsApiUrl}/forwarder/getForwarderIsExpress/${facilityCode}/${isExpress}`;
    return this.http.get(url);
  }

  searchRmbRecommendForwarder(params: any): Observable<any>{
    const url = `${environment.logisticsApiUrl}/forwarder/searchRmbRecommendForwarder`;
    return this.http.post(url,params);
  }

  saveRmbRecommendForwarder(params: any): Observable<any>{
    const url = `${environment.logisticsApiUrl}/forwarder/saveRmbRecommendForwarder`;
    return this.http.post(url, params);
  }

  deleteRmbRecommendForwarder(params: any): Observable<any>{
    const url = `${environment.logisticsApiUrl}/forwarder/deleteRmbRecommendForwarder`;
    return this.http.post(url, params);
  }

  exportFileByRecommendForwarderType(request: any, forwarderType: string, language: string): Observable<any> {
    const url = `${environment.logisticsApiUrl}/forwarder/exportFileByRecommendForwarderType/${forwarderType}/${language}`;
    return this.http.post(url, request, { responseType: 'blob' });
  }

  uploadRecommendForwarderFile(file: any, forwarderType: string, facilityList: any): Observable<any> {
    let url = `${environment.logisticsApiUrl}/forwarder/uploadRecommendForwarderFile`;

    const formData: FormData = new FormData();
    formData.append('file', file);
    formData.append('forwarderType', forwarderType);
    formData.append('facilityList', facilityList.join(','));

    console.log(file instanceof File);
    let response = this.http.post(url, formData ,  {
      reportProgress: true,
      responseType: 'json'
    } );
    return response;
  }
}
